import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { router } from "@/router";
import { Toaster } from "sonner";
import { makeTheme } from "@/theme";

import { Box, GlobalStyles } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { LanguageProvider } from "./contexts/LanguageContext";

import ChatSettingsModal from "@/components/organisms/chat/settings";

import { settingsState } from "@/state/settings";

import "./App.css";
import { useConfig } from "./client/useConfig";
import { useChatSession } from "./client/useChatSession";
import { overrideTheme } from "./utils/theme";
import "@fontsource/figtree";
import "@fontsource/figtree/700.css"; // Bold (or 600 for semi-bold, 800+ for extra bold)
// import { useChatInteract } from "./client/useChatInteractV2";
// import { useChatMessages } from "./client/useChatMessages";

function App() {
  const fontFamily = "Figtree, sans-serif";

  const { config } = useConfig();
  const { theme: themeVariant } = useRecoilValue(settingsState);
  const { chatProfile, setChatProfile } = useChatSession();
  // const { threadId, messages } = useChatMessages();
  // const { sendAskFileMessage } = useChatInteract();

  const theme = overrideTheme(makeTheme(themeVariant, fontFamily));
  const configLoaded = !!config;

  // useEffect(() => {
  //   if (configLoaded && !threadId && (!messages || messages.length === 0)) {
  //     sendAskFileMessage();
  //   }
  // }, [configLoaded, threadId, messages]);

  useEffect(() => {
    if (configLoaded && config?.chatProfiles.length && !chatProfile) {
      // Autoselect the first default chat profile
      const defaultChatProfile = config.chatProfiles.find(
        (profile) => profile.default
      );
      if (defaultChatProfile) {
        setChatProfile(defaultChatProfile.name);
      } else {
        setChatProfile(config.chatProfiles[0].name);
      }
    }
  }, [configLoaded, config?.chatProfiles.length, chatProfile]);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles
        styles={{
          body: { backgroundColor: theme.palette.background.default },
          p: { marginTop: "1em", marginBottom: "1em" },
        }}
      />
      <Toaster
        className="toast"
        position="top-right"
        offset={{ top: 65, right: 16 }}
        closeButton={true}
        toastOptions={{
          style: {
            fontFamily: theme.typography.fontFamily,
            background: theme.palette.background.default,
            border: `1px solid ${theme.palette.divider}`,
            color: theme.palette.text.primary,
          },
        }}
      />
      <Box
        display="flex"
        height="100vh"
        maxHeight="-webkit-fill-available"
        width="100vw"
        sx={{ overflowX: "hidden" }}
        className={`theme-${themeVariant}`}
      >
        <ChatSettingsModal />
        <LanguageProvider>
          <RouterProvider router={router} />
        </LanguageProvider>
      </Box>
    </ThemeProvider>
  );
}

export default App;
